/*
 *   File : order-history.js
 *   Author : https://evoqins.com
 *   Description : Order history modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

///Custom components
import { useEffect, useRef, useState } from 'react';
import { OrderCard } from '../Card';
import { Icon } from '../Icon';
import { Loader, Pagination } from '../Others';
import { TextButton } from '../Buttons';

const ITEMS_PER_PAGE = 10;

const OrderHistoryModal = (props) => {

    const scrollRef = useRef();

    const [historyData, setHistoryData] = useState([]);

    // useEffect(() => {

    //     if (props.orderHistory) {
    //         setHistoryData(prev => [...prev, ...props.orderHistory])
    //     }
    // }, [props.orderHistory]);


    useEffect(() => {
        if (props.orderHistory && props.orderHistory.length > 0) {
            setHistoryData(prev => {
                const existingIds = new Set(prev.map(item => item.order_id));
                const newItems = props.orderHistory.filter(
                    item => !existingIds.has(item.order_id)
                );
                return [...prev, ...newItems];
            });
        }
    }, [props.orderHistory]);

    console.log("historyData", historyData);


    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("order-history-modal-close");
        button.click();
        props.handleClose();
    };

    // handle success
    const _handleSuccess = () => {
        _handleCloseModal();
        props.handleSuccess();
    };

    const _handleViewMore = () => {
        props.handleViewMore();
    }


    // if (scrollRef.current) {
    //     scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    // }

    return (
        <div className="modal fade"
            id="order-history-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="OrderHistoryModalLabel"
            aria-hidden="true">
            <div className={` modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-24`}>
                <span id='order-history-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-24 overflow-hidden border-0 pb-4">
                    <div className='modal-header border-0 pt-4 px-4 pb-3 d-flex justify-content-between align-items-center'>
                        <div className='d-flex align-items-center gap-6px'>
                            {/* <Icon icon="back-icon"
                                className="cursor-pointer"
                                size={24}
                                onClick={_handleCloseModal} /> */}
                            <h4 className='mb-0 e-text-custom-blue e-alt-font e-font-16 e-font-weight-600 line-height-22px text-center '>
                                Order history
                            </h4>
                        </div>
                        <Icon
                            icon="close"
                            className="d-flex e-bg-bright-gray-light border-radius-24 cursor-pointer ms-auto"
                            size="1.5rem"
                            onClick={_handleCloseModal}
                        />
                    </div>

                    <div className="modal-body pt-0 px-4 pb-0" >
                        {props.forcedLoader ?
                            <Loader />
                            :
                            <>
                                <div ref={scrollRef} className="d-flex flex-column gap-3 w-100">
                                    {
                                        historyData.map((item, index) => <OrderCard key={index} order={item} />)
                                    }


                                </div>
                                {props.currentPage !== props.totalPage &&
                                    <div className='d-flex justify-content-end pt-3 pb-1'>
                                        {props.modalHistoryLoader ?
                                            <div className="loader justify-content-end">
                                                <div className="ball"></div>
                                                <div className="ball"></div>
                                                <div className="ball"></div>
                                                <div className="ball"></div>
                                            </div>
                                            :
                                            <TextButton name="View more"
                                                onClick={_handleViewMore} />
                                        }
                                    </div>
                                }
                            </>
                        }
                    </div>

                    {/* <div className='modal-footer border-0 pb-0 px-4'>
                        <Pagination itemsPerPage={ITEMS_PER_PAGE}
                            totalPage={props.orderHistory.total_page}
                            currentPage={currentPage}
                            forcePage={currentPage - 1}
                            totalItems={props.orderHistory.total_count}
                            showFirstLastPages={true}
                            pageRangeDisplayed={0}
                            marginPagesDisplayed={0}
                            onChange={_handlePagination} />
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default OrderHistoryModal;
